import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Loader2 } from 'lucide-react';

/** SaaS operator routes: platform administrators only. */
export default function PlatformProtectedRoute({ children }) {
  const { loading, isAuthenticated, isPlatformAdmin, isTenantUser } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  if (isTenantUser) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  if (!isPlatformAdmin) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}
